module.exports = ".ssf-warning__item, .ssf-warning__icon, .ssf-warning__text {\n  color: #D59120;\n  display: table-cell;\n  vertical-align: middle; }\n\n.ssf-warning__text {\n  font-size: 0.8rem;\n  padding: 0 0.2rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/warning/warning.component.scss
// module id = 814
// module chunks = 3